import React from "react";
//Limitless imports
import { log as pilog } from "@limitless/common/utils";
import { useNotificationContext } from "@limitless/common/hooks/notification/NotificationContext";
import { useExpertMessageContext } from "../expert-message/ExpertMessageContext";
const INITIAL_EXTRA_INFO_STATE = {
  selected: null,
  finalData: [],
  searchKey: "",
  rowsPerPage: 5,
  page: 0,
  copiedKey: ""
};
const getExtraInfoData = (message, searchKey = "") => {
  const log = pilog.getLogger("ExtraInfoHook");
  let rawData = {};
  if (message.customerData && message.customerData !== null) {
    try {
      rawData = JSON.parse(message.customerData);
    } catch (error) {
      log.debug("Failed to parse customerData, must be JSON already", error);
      rawData = message.customerData;
    }
  }
  if (message.readOnlyTags.length > 0) {
    let CRMTags = {};
    message.readOnlyTags.forEach((tag, index) => {
      CRMTags = {
        ...CRMTags,
        [`Meta Tag ${index + 1}`]: tag
      };
    });
    rawData = {
      ...rawData,
      "CRM Tags": CRMTags
    };
  }
  const finalData = [];
  if (rawData !== null) {
    Object.keys(rawData).map(key => {
      const nestedKeys = Object.keys(rawData[key]);
      nestedKeys.map(nestedKey => {
        const values = `${key} ${nestedKey} ${rawData[key][nestedKey]}`;
        if (searchKey !== "") {
          if (values.toLowerCase().includes(searchKey.toLowerCase())) {
            finalData.push({
              category: key,
              attribute: nestedKey,
              value: rawData[key][nestedKey]
            });
          }
        } else {
          finalData.push({
            category: key,
            attribute: nestedKey,
            value: rawData[key][nestedKey]
          });
        }
      });
    });
  }
  log.debug({
    finalData
  });
  return {
    finalData
  };
};
export const useExtraInfo = () => {
  const messageContext = useExpertMessageContext();
  const {
    addInfoNotification
  } = useNotificationContext();
  const [extraInfo, setExtraInfo] = React.useState({
    ...INITIAL_EXTRA_INFO_STATE,
    ...getExtraInfoData(messageContext.message)
  });
  const updateInfoCriteria = newCriteria => {
    setExtraInfo({
      ...extraInfo,
      ...newCriteria
    });
  };
  const onValueCopied = newCriteria => {
    updateInfoCriteria(newCriteria);
    addInfoNotification("Value copied to clipboard");
  };
  const onFilterData = ({
    searchKey
  }) => {
    updateInfoCriteria({
      ...getExtraInfoData(messageContext.message, searchKey),
      searchKey,
      page: INITIAL_EXTRA_INFO_STATE.page,
      copiedKey: INITIAL_EXTRA_INFO_STATE.copiedKey
    });
  };
  const onUpdateSelectedItem = newCriteria => {
    updateInfoCriteria({
      ...newCriteria,
      copiedKey: INITIAL_EXTRA_INFO_STATE.copiedKey
    });
  };

  //if the messageId changes, reset the extra info
  React.useEffect(() => {
    setExtraInfo({
      ...INITIAL_EXTRA_INFO_STATE,
      ...getExtraInfoData(messageContext.message)
    });
  }, [messageContext.message.messageId]);
  return {
    ...extraInfo,
    updateInfoCriteria,
    onValueCopied,
    onFilterData,
    onUpdateSelectedItem
  };
};